import { render } from "./ServerConfig.vue?vue&type=template&id=3208c9b3"
import script from "./ServerConfig.vue?vue&type=script&lang=js"
export * from "./ServerConfig.vue?vue&type=script&lang=js"

import "./ServerConfig.vue?vue&type=style&index=0&id=3208c9b3&lang=scss"

import exportComponent from "C:\\Devprojects\\cedaci-compass\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__